/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deals_Drop_HereInputs */

const cs_deals_drop_here = /** @type {(inputs: Deals_Drop_HereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přetáhněte sem`)
};

const en_deals_drop_here = /** @type {(inputs: Deals_Drop_HereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drop here`)
};

/**
* | output |
* | --- |
* | "Drop here" |
*
* @param {Deals_Drop_HereInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const deals_drop_here = /** @type {((inputs?: Deals_Drop_HereInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deals_Drop_HereInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deals_drop_here(inputs)
	return cs_deals_drop_here(inputs)
});